import React, { useState } from 'react';
import { Tabs, TabsProps } from 'antd';
import ImageGalleryTab from './ImageGalleryTab';
import SocialPostsTab from './SocialPostsTab';
import CalendarItemDetailModal from './CalendarItemDetailModal';
import CalendarTab from './CalendarTab';
import { useFacebookSDK } from '@core/hooks';

type Props = {};

enum StudioTabKey {
  ImageGallery = 'image-gallery',
  Calendar = 'calendar',
  UpcomingPosts = 'upcoming-posts',
}

const RestogramStudioScreen = (props: Props) => {
  useFacebookSDK();
  const [selectedTab, setSelectedTab] = useState(StudioTabKey.ImageGallery);

  const handleOnTabChanged = (key: string) => {
    setSelectedTab(key as any);
  };

  const tabs: TabsProps['items'] = [
    {
      key: StudioTabKey.ImageGallery,
      label: `Image Gallery`,
      children: <ImageGalleryTab />,
    },
    {
      key: StudioTabKey.Calendar,
      label: `Calendar`,
      children: <CalendarTab />,
    },
    {
      key: StudioTabKey.UpcomingPosts,
      label: `Upcoming Posts`,
      children: <SocialPostsTab />,
    },
  ];

  return (
    <React.Fragment>
      <div className="screen-card">
        <h3>Social Studio</h3>
        <Tabs defaultActiveKey={selectedTab} items={tabs} onChange={handleOnTabChanged} />
      </div>
      <CalendarItemDetailModal />
    </React.Fragment>
  );
};

export default RestogramStudioScreen;
